module.exports = __webpack_public_path__ + "img/Phone_05.078140f9.jpg";